import React, { Component } from "react";
import PropTypes from "prop-types";
import { ScrollView } from "react-native";
import { connect } from "react-redux";
import * as SecureStore from "../DeviceAsyncStorage";
import * as CONSTANTS from "../../../assets/consts";
import Theme from "../../argon-ui/Theme";
class RBSheetInner extends Component {
  static propTypes = {
    AreaReducer: PropTypes.object,
    DeviceReducer: PropTypes.object,
    selectedAreaDeviceType: PropTypes.string,
    selectedAreaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    selectedAreaName: PropTypes.string,
    onToggleItemPress: PropTypes.func,
    children:PropTypes.node
  };

  constructor(props) {
    super(props);
    this.state = {
      accessToken: "",
      serverUrl: "",
    };
  }

  // componentDidMount() {
  //   const { currentServer, serverUrl } = this.props.AppReducer;
  //   this.setState({
  //     accessToken: currentServer.accessToken,
  //     serverUrl,
  //   });
  // }

  handleOnTogglePress = (deviceId, currentValue) => {
    this.props.onToggleItemPress &&
      this.props.onToggleItemPress(
        this.props.selectedAreaDeviceType,
        deviceId,
        currentValue
      );
  };

  updateDeviceListByType = () => {
    var _devices = [];
    for (var a in this.props.AreaReducer.areas) {
      let area = this.props.AreaReducer.areas[a];
      if (
        (area && area.areaId == this.props.selectedAreaId) ||
        area.areaUId == this.props.selectedAreaId
      ) {
        for (var d in this.props.DeviceReducer.list) {
          let dvc = this.props.DeviceReducer.list[d];
          if (
            (area.devices.includes(dvc.deviceId) ||
              area.uDevices.includes(dvc.deviceUId)) &&
            dvc.deviceType == this.props.selectedAreaDeviceType
          ) {
            _devices.push(dvc);
          }
        }
        break;
      }
    }

    return _devices;
  };

  render() {
    return (
      <ScrollView
        style={{
          width: "100%",
          // backgroundColor: Theme.COLORS.WHITE,
        }}
      >
        {/* {this.props.selectedAreaName}  */}
        {/* {this.props.selectedAreaDeviceType} */}
        {this.props.children}
        {/* {this.renderDevicesList(_devices)} */}
      </ScrollView>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    AreaReducer: state.AreaReducer,
    AppReducer: state.AppReducer,
  };
};

export default connect(mapStateToProps, null)(RBSheetInner);
